<script setup>
import { Inertia } from '@inertiajs/inertia';
import { PlusIcon, InformationCircleIcon } from "@heroicons/vue/outline"
import { ref } from 'vue'

import OrganisationList from '@/Components/Models/Organisation/List'

const props = defineProps({
    organisations: {
        type: Array,
        default: () => ([]),
    },
})

function itemClicked(item){
    Inertia.visit('/organisations/' + item.id)
}

function addNew(){
    Inertia.visit('/organisations/create')
}
</script>

<template>
    <SectionCard :full-width="true">

        <template #header>
			<div class="flex justify-between items-center">
				<span class="text-lg font-medium text-gray-900 mb-0">Member Organisations</span>
				<Button 
					@click="addNew" 
					color="blue"
				>
					<PlusIcon class="w-4 h-4 mr-2 inline" /> Add New
				</Button>
			</div>
        </template>
        
		<OrganisationList 
			:items="organisations" 
			@item-clicked="itemClicked" 
		/>

        <template #footer>
			<Button 
				@click="addNew" 
				color="blue"
			>
				<PlusIcon class="w-4 h-4 mr-2 inline" /> Add New
			</Button>
        </template>

    </SectionCard>
</template>